document.querySelector('header .header__icon--search').addEventListener("click", function (e) {
  const parentEl = this.parentNode;
  parentEl.classList.add("open-search");
});

document.querySelector('header .search-modal__close-button').addEventListener("click", function (e) {
  const parentEl = this.closest(".search-modal").parentNode;
  parentEl.classList.remove("open-search");
});